import { Page, Card, Button, ButtonGroup } from "@shopify/polaris";
import React from "react";
import { useAppContext } from "../../context";
import { checkRole, getParamByRole, reducerFn } from "../../helper";
import AmazonIdeaFilter from "./amazon-idea-filter";
import { AmazonIdeaProvider } from "./context";
import { useQuery } from "@apollo/react-hooks";
import { GET_AMAZON_IDEAS } from "../../graphql/queries/amazon-idea";
import { get } from "lodash";
import AmazonIdeaTable from "./amazon-idea-table";
import useToggle from "../../hooks/useToggle";
import AmazonIdeaDivision from "./actions/amazon-idea-division";
import AmazonIdeaTabs from "./amazon-idea-tab";

function AmazonIdea() {
    const { currentUser } = useAppContext();
    const pathname = getParamByRole(currentUser);
    const [open, toggleOpen] = useToggle(false);
    const { isChannelSupporter, isChannelSupportLeader } =
        checkRole(currentUser);
    const isSupportRole = isChannelSupporter || isChannelSupportLeader;

    return (
        <Page
            title="Amazon Ideas"
            fullWidth
            primaryAction={
                !isChannelSupporter ? (
                    <ButtonGroup>
                        {isSupportRole ? null : (
                            <Button
                                primary
                                url={`/${pathname}/amazon-ideas/create`}
                            >
                                Create Amazon Idea
                            </Button>
                        )}
                        <Button onClick={toggleOpen}>Division</Button>
                    </ButtonGroup>
                ) : null
            }
        >
            <Card sectioned>
                <AmazonIdeaFilter />
            </Card>
            <Card>
                <AmazonIdeaTabs />
                <AmazonIdeaTable />
            </Card>

            <AmazonIdeaDivision open={open} onClose={() => toggleOpen(false)} />
        </Page>
    );
}

export default function AmazonIdeaWrap() {
    const { store } = useAppContext();

    const [filter, setFilter] = React.useReducer(reducerFn, {
        limit: 20,
        offset: 0,
        search: "",
        status: null,
        authorIDs: null,
        pickerIDs: null,
        // storeTypeIDs: null,
        storeIDs: store?.id && store.id !== "all"  ? [store.id] : null,
        types: null,
        range: null,
        isPersonalized: null,
        isPicked: null,
    });

    const { data, loading, error, refetch } = useQuery(GET_AMAZON_IDEAS, {
        variables: {
            filter,
        },
        fetchPolicy: "no-cache",
    });

    return (
        <AmazonIdeaProvider
            filter={filter}
            setFilter={setFilter}
            loading={loading}
            error={error}
            total={getTotal(data)}
            amazonIdeas={getAmazonIdeas(data)}
            aggregations={getAggregations(data)}
            refetch={refetch}
        >
            <AmazonIdea />
        </AmazonIdeaProvider>
    );
}

function getTotal(data) {
    return get(data, "getAmazonIdeas.total");
}

function getAmazonIdeas(data) {
    return get(data, "getAmazonIdeas.nodes") || [];
}

function getAggregations(data) {
    return get(data, "getAmazonIdeas.aggregations") || {};
}
